/** A karaoke night runs past midnight, so a song at 1am belongs to the evening
 * before. Nights turn over at 6am local time. */
const NIGHT_STARTS_AT_HOUR = 6;

/** The local day a timestamp's night belongs to, as a start-of-day epoch. */
export function nightOf(ms: number): number {
  const at = new Date(ms);
  if (at.getHours() < NIGHT_STARTS_AT_HOUR) at.setDate(at.getDate() - 1);
  return new Date(at.getFullYear(), at.getMonth(), at.getDate()).getTime();
}

/** 'Saturday 6 September', with the year once the night is not this one. The
 * weekday is formatted apart because en-GB puts a comma after it. */
export function formatNightLabel(nightStart: number, now = new Date()): string {
  const night = new Date(nightStart);
  const weekday = night.toLocaleDateString('en-GB', { weekday: 'long' });
  const date = night.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    ...(night.getFullYear() === now.getFullYear() ? {} : { year: 'numeric' }),
  });
  return `${weekday} ${date}`;
}

/** 'March', or 'March 2025' once it is not this year. */
export function formatMonthLabel(ms: number, now = new Date()): string {
  const month = new Date(ms);
  return month.toLocaleDateString('en-GB', {
    month: 'long',
    ...(month.getFullYear() === now.getFullYear() ? {} : { year: 'numeric' }),
  });
}

export interface Night<T> {
  nightStart: number;
  songs: T[];
}

/** Rows newest first, split into the nights they were sung on, each night
 * keeping the order it came in. */
export function groupByNight<T extends { sangAt: number }>(rows: readonly T[]): Night<T>[] {
  const nights: Night<T>[] = [];
  for (const row of rows) {
    const nightStart = nightOf(row.sangAt);
    const current = nights.at(-1);
    if (current?.nightStart === nightStart) current.songs.push(row);
    else nights.push({ nightStart, songs: [row] });
  }
  return nights;
}
